export const START_LOADING = 'START_LOADING';
export type START_LOADING = typeof START_LOADING;

export const END_LOADING = 'END_LOADING';
export type END_LOADING = typeof END_LOADING;
